var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA836766Bf280C47975Ca8984Cd528C0Bf25470Ec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 2480 2003",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 2",
    filter: "url(#filter0_f_2002_81)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1240,
    cy: 1001.5,
    rx: 556,
    ry: 317.5,
    fill: "var(--fill-0, #00B14F)",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2002_81",
    x: 0,
    y: 0,
    width: 2480,
    height: 2003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 342,
    result: "effect1_foregroundBlur_2002_81"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA836766Bf280C47975Ca8984Cd528C0Bf25470Ec);
export default __webpack_public_path__ + "static/media/a836766bf280c47975ca8984cd528c0bf25470ec.527a0b8372245752593f577365f038a3.svg";
export { ForwardRef as ReactComponent };